import { Component, input } from '@angular/core';
import { BaseIconComponent } from './base-icon.component';

@Component({
  selector: 'app-paperclip-icon',
  standalone: true,
  template: `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      [attr.width]="width()"
      [attr.height]="height()"
      [attr.viewBox]="viewBox()"
      [attr.fill]="fill()"
      [style.color]="color()"
      [class]="iconClass()">
      <path
        d="M11.3131 19.1667C8.83314 19.1667 6.81314 17.1467 6.81314 14.6667V10.6667C6.81314 7.82 9.13314 5.5 11.9798 5.5C14.8265 5.5 17.1465 7.82 17.1465 10.6667V14.3333C17.1465 15.8933 15.8731 17.1667 14.3131 17.1667C12.7531 17.1667 11.4798 15.8933 11.4798 14.3333V12C11.4798 11.7267 11.7065 11.5 11.9798 11.5C12.2531 11.5 12.4798 11.7267 12.4798 12V14.3333C12.4798 15.3467 13.2998 16.1667 14.3131 16.1667C15.3265 16.1667 16.1465 15.3467 16.1465 14.3333V10.6667C16.1465 8.36667 14.2798 6.5 11.9798 6.5C9.67981 6.5 7.81314 8.36667 7.81314 10.6667V14.6667C7.81314 16.5933 9.37981 18.1667 11.3131 18.1667C11.5865 18.1667 11.8131 18.3933 11.8131 18.6667C11.8131 18.94 11.5931 19.1667 11.3131 19.1667Z"
        fill="currentColor" />
    </svg>
  `,
})
export class PaperclipIconComponent extends BaseIconComponent {
  override viewBox = input<string>('0 0 24 24');
}
